// MobileTopNavbar.jsx
import React from "react";
import logo from "assets/logo.png";

const MobileTopNavbar = () => (
  <div className="lg:hidden w-full flex items-center px-4 py-3 bg-white/95 backdrop-blur-md shadow-sm shrink-0">
    <a href="https://onebotads.net" target="_blank" rel="noopener noreferrer">
      <img src={logo} alt="OnebotAds" className="h-7" />
    </a>
  </div>
);

export default MobileTopNavbar;
